import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  HostBinding, OnDestroy, Input, ChangeDetectorRef
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { JanusService, StateService } from '@shared/services';
import { MultiMedia } from '@models';

@Component({
  selector: 'thevatra-participants',
  templateUrl: './participants.component.html',
  styleUrls: ['./participants.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParticipantsComponent implements OnInit, OnDestroy {
  destroyed$ = new Subject<boolean>();
  @HostBinding('class.opened') isOpened = false;
  public videosArray: MultiMedia[];
  @Input() set videos(videos: MultiMedia[] | null) {
    this.videosArray = videos || [];
    // TODO should we make copy? and sort in one run
    this.videosArray = this.videosArray
      .sort((a, b) => a.video.id - b.video.id)
      .sort((a, b) => Number(a.video.remote) - Number(b.video.remote));
    this.cdr.detectChanges();
  }
  get videos(): MultiMedia[] {
    return this.videosArray;
  }

  constructor(public stateService: StateService,
              public janusService: JanusService,
              private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.stateService.isParticipantsShown$.pipe(
      takeUntil(this.destroyed$)
    ).subscribe((isParticipantsShown: boolean) => {
      this.isOpened = isParticipantsShown;
    });
  }

  trackByMethod(index: number, el: MultiMedia): number {
    return el.video.id;
  }

  closeMenu() {
    this.stateService.isParticipantsShown = false;
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
